
import Vue from "vue"
import { mapActions, mapState } from "vuex"
import ActionDialog from "@/components/ActionDialog.vue"
import RangesForm from "@/ranges/RangesForm.vue"
import rangesStub from "./ranges.stub"

export default Vue.extend({
  name: "RangesEditDialog",

  components: {
    RangesForm,
    ActionDialog
  },

  props: {
    shown: { type: Boolean, default: false },
    range: { type: Object, required: true }
  },

  data: function() {
    return {
      visible: this.shown,
      form: { ...rangesStub }
    }
  },

  computed: mapState("ranges", {
    rangesStateEditOneIsLoading: "editOneIsLoading"
  }),

  watch: {
    visible(visible): void {
      this.$emit("update:shown", visible)
    },
    shown(visible): void {
      this.visible = visible
    },
    range: {
      immediate: true,
      handler(data): void {
        this.form = { ...data }
      }
    }
  },

  methods: {
    ...mapActions("ranges", {
      rangesActionsEditOne: "editOne"
    }),

    submit(): void {
      this.$refs.rangesForm.submit(async () => {
        try {
          await this.rangesActionsEditOne(this.form)
          this.$success(this.$t("rangesActionsEditOneSuccess", {
            rangesName: this.form.name
          }))
          this.close()
        } catch(e) {
          this.$error(e.message)
        }
      })
    },

    close(): void {
      this.visible = false
    }
  }
})
